import * as Safe from "safe-portals";
import { makeActionTypeDefinition } from "@flow/common/action_type";
import { CanonicalQuestionSerializer } from "@flow/plugins/identity_crm/common/id_api_definitions";
import { Serializers } from "@flow/common/types";

/**
 * Represents all the values the admin user can set to configure a Random Common Question.
 * This is NOT the same as the values that are passed to the member facing ActionComponent.
 */
const ConfigSerializer = Safe.obj({
  // here you add action properties that can be edited when creating a journey
  // they are passed to ../frontend/admin/EditRandomCommonQuestionAction
  title: Safe.str,
  pre_question_html: Safe.str,
  post_question_html: Safe.str,
  submit_button_label: Safe.str,
  skip_button_label: Safe.str,
});

/**
 * This data is passed to member facing component when this action is begun
 *  it is generated in ../backend/action_type_handlers
 */
const FrontendDataSerializer = Safe.obj({
  title: Safe.str,
  consent_configs: Safe.array(Serializers.consentConfig),
  question: Safe.optional(CanonicalQuestionSerializer),
  pre_question_html: Safe.str,
  post_question_html: Safe.str,
  submit_button_label: Safe.str,
  skip_button_label: Safe.str,
});

const newActionDefaults = {
  title: "",
  pre_question_html:
    "We’re finding out more about our supporters so we can build campaigns that reflect the whole country. " +
    "If you choose to answer this question, you are consenting to 38 Degrees using this to help plan better " +
    "campaigns, serve our supporters better and have an impact on decision makers.",
  post_question_html: "",
  submit_button_label: "",
  skip_button_label: "",
};

export const RandomCommonQuestionAction_def = makeActionTypeDefinition({
  plugin: "survey",
  // action type identifier. don't change this without migrating data
  action_type: "survey:RandomCommonQuestionAction",
  supports_a_b_tests: true,
  custom_config_type: ConfigSerializer,
  // these are the default action properties when a new RandomCommonQuestionAction is created
  custom_config_defaults: newActionDefaults,
  // this data is passed to  member facing frontend ../frontend/member/RandomCommonQuestionAction when this action is begun
  // it is generated in ../backend/action_type_handlers
  custom_data_type: FrontendDataSerializer,
  check_valid: (config) => {
    const errors: Record<string, string> = {};

    // Send a message config validation
    if (config.title.length === 0) {
      errors.title = "Title is required";
    }

    return { valid: Object.keys(errors).length === 0, errors: errors };
  },
});

export type ActionConfig = Safe.TypeIn<typeof ConfigSerializer>;
export type ActionCustomData = Safe.TypeIn<typeof FrontendDataSerializer>;
